import { Injectable } from '@angular/core';
import { ConstantConfig } from '../config/constant.config';
import { EncryptDecryptService } from './encrypt-decrypt.service';

@Injectable()
export class LocalStorageService {
    constructor(
        private edService: EncryptDecryptService,
    ) { }
    /**
     * Will set the data into session storage
     * @storageKey: The key against which the data is to store
     * @data: The data to store
     */
    set(storageKey:string, data:any) {
        if (typeof (Storage) !== 'undefined') {
            localStorage[storageKey] = data;
        } else {
            alert('Sorry, your browser does not support web storage...');
        }
    }

    /**
     * Will get the data from session storage
     * @storageKey: The key against which the data is stored
     */
    get(storageKey:string) {
        return localStorage[storageKey];
    }

    /**
     * Will remove the data from session storage
     * @storageKey: The key against which the data is stored
     */
    remove(storageKey:string) {
        delete localStorage[storageKey];
    }

    setEncryptData(key:string,data:any){
      const encryptData = this.edService.encrypt(JSON.stringify(data));
      this.set(key, encryptData);
    }

    getDecryptedData(key:string) {
      const data = this.get(key) || '';
      return JSON.parse(this.edService.decrypt(data));
    }

    setEncryptSessionData(key: string, data: any) {
      try {
        key = `${sessionStorage[ConstantConfig.CLIENT_SLUG]}_${key}`;
        const encrypted = this.edService.encrypt(JSON.stringify(data ?? {}));
        sessionStorage.setItem(key, encrypted);
      } catch {
      }
    }

    getDecryptedSessionData(key: string) {
      key = `${sessionStorage[ConstantConfig.CLIENT_SLUG]}_${key}`;
      try {
        const decrypted = this.edService.decrypt(sessionStorage.getItem(key) || '');
        return decrypted ? JSON.parse(decrypted) : null;
      } catch {
        return null;
      }
    }
    
    clearSessionData(options?: { 
      key?: string; 
      clearAll?: boolean; 
    }): void {
      if (options?.clearAll) {
        sessionStorage.clear();
        return;
      }

      if (options?.key) {
        sessionStorage.removeItem(`${sessionStorage[ConstantConfig.CLIENT_SLUG]}_${options?.key}`);
        return;
      }
    }

    removeClientInfo(clientId:string,skipLoginAsClient:boolean=false){
      this.remove(clientId + "_" + ConstantConfig.AUTH_TOKEN_EXPIRY);
      this.remove(clientId + "_" + ConstantConfig.AUTH_TOKEN);
      this.remove(clientId + "_" + ConstantConfig.USER_INFO);
      this.remove(clientId + "_" + ConstantConfig.SELECTED_THEME);
      !skipLoginAsClient && this.remove(clientId + "_"  + ConstantConfig.LOGIN_AS_CLIENT);
    }
}
